<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="会员账户管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="企业名称">
            <el-input v-model="params.PersonName" placeholder="请输入企业名称" clearable />
          </el-form-item>
          <el-form-item label="操作类型">
            <el-select v-model="params.IntegralType" placeholder="请选择操作类型" clearable>
              <el-option label="充值" :value="1"></el-option>
              <el-option label="消费" :value="0"></el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item label="操作时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.IntegralStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.IntegralEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>

        </template>
        <template slot="table">
          <el-table-column prop="EnterpriseName" label="企业名称" align="center" width="60" />
       
          <el-table-column prop="IntegralType" label="操作类型" align="center" width="60" />
          <el-table-column prop="IntegralTime" label="操作时间" />
          <el-table-column prop="Money" label="金额" />
          <el-table-column prop="Notices" label="备注" />
          
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
         PersonName: "",
         IntegralType: "",
         IntegralStarttime: null,
        IntegralEndtime: null,
        },
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{EnterpriseName:"淘店",IntegralType:"充值",IntegralTime:"2024-01-11 09:01:12",Money:5000,Notices:""},{EnterpriseName:"淘店",IntegralType:"消费",IntegralTime:"2024-01-12 11:22:35",Money:220,Notices:"订单:O20240115033"}]});
      })
    },
     
    },
  };
  </script>